angular
    .module('accessWebClient')
    .constant('FolderTypeIcons', {
        folder: 'folder',
        shared: 'shared-folder'
    })
    .constant('FileTypeIcons', {
        // Archives
        '7z': 'zip',
        gz: 'zip',
        rar: 'zip',
        tar: 'zip',
        zip: 'zip',
        // Audio
        aac: 'music',
        mp3: 'music',
        wav: 'music',
        wma: 'music',
        m4a: 'music',
        ogg: 'music',
        oga: 'music',
        opus: 'music',
        flac: 'music',
        // Code
        access: 'java',
        css: 'code1',
        html: 'html',
        ini: 'code1',
        jar: 'java',
        java: 'java',
        js: 'code2',
        json: 'code1',
        reg: 'code2',
        xml: 'html',
        // Fonts
        ttf: 'font',
        // Images
        ai: 'image',
        bmp: 'image',
        eps: 'image',
        gif: 'image',
        ico: 'image',
        jpe: 'image',
        jpeg: 'image',
        jpg: 'image',
        png: 'image',
        psd: 'image',
        // Office
        csv: 'csv',
        doc: 'docx',
        docx: 'docx',
        dotx: 'dotx',
        email: 'email',
        keynote: 'keynote',
        numbers: 'numbers',
        odp: 'odp',
        ods: 'ods',
        odt: 'odt',
        pages: 'pages',
        pdf: 'pdf',
        potx: 'potx',
        pps: 'ppsx',
        ppsx: 'ppsx',
        ppt: 'pptx',
        pptx: 'pptx',
        rtf: 'rtf',
        txt: 'txt',
        xls: 'xlsx',
        xlsx: 'xlsx',
        xlt: 'xltx',
        xltx: 'xltx',
        vcard: 'vcard',
        vsdx: 'vsdx',
        vssx: 'vssx',
        vstx: 'vstx',
        // Other
        file: 'file',
        // System
        exe: 'exe',
        dll: 'dll',
        real: 'file',
        // Video
        avi: 'video',
        mov: 'video',
        mpeg: 'video',
        mpg: 'video',
        wmv: 'video',
        mp4: 'video',
        m4v: 'video',
        ogv: 'video',
        webm: 'video',
        mkv: 'video'
    });
